const timezones = [
    'Asia/Kabul',
    'Europe/Tirane',
    'Africa/Algiers',
    'Pacific/Pago_Pago',
    'Europe/Andorra',
    'Africa/Luanda',
    'America/Anguilla',
    'Antarctica/Casey',
    'Antarctica/Davis',
    'Antarctica/DumontDUrville',
    'Antarctica/Mawson',
    'Antarctica/McMurdo',
    'Antarctica/Palmer',
    'Antarctica/Rothera',
    'Antarctica/Syowa',
    'Antarctica/Troll',
    'Antarctica/Vostok',
    'America/Antigua',
    'America/Argentina/Buenos_Aires',
    'America/Argentina/Catamarca',
    'America/Argentina/Cordoba',
    'America/Argentina/Jujuy',
    'America/Argentina/La_Rioja',
    'America/Argentina/Mendoza',
    'America/Argentina/Rio_Gallegos',
    'America/Argentina/Salta',
    'America/Argentina/San_Juan',
    'America/Argentina/San_Luis',
    'America/Argentina/Tucuman',
    'America/Argentina/Ushuaia',
    'Asia/Yerevan',
    'America/Aruba',
    'Antarctica/Macquarie',
    'Australia/Adelaide',
    'Australia/Brisbane',
    'Australia/Broken_Hill',
    'Australia/Darwin',
    'Australia/Eucla',
    'Australia/Hobart',
    'Australia/Lindeman',
    'Australia/Lord_Howe',
    'Australia/Melbourne',
    'Australia/Perth',
    'Australia/Sydney',
    'Europe/Vienna',
    'Asia/Baku',
    'America/Nassau',
    'Asia/Bahrain',
    'Asia/Dhaka',
    'America/Barbados',
    'Europe/Minsk',
    'Europe/Brussels',
    'America/Belize',
    'Africa/Porto-Novo',
    'Atlantic/Bermuda',
    'Asia/Thimphu',
    'America/La_Paz',
    'America/Kralendijk',
    'Europe/Sarajevo',
    'Africa/Gaborone',
    'America/Araguaina',
    'America/Bahia',
    'America/Belem',
    'America/Boa_Vista',
    'America/Campo_Grande',
    'America/Cuiaba',
    'America/Eirunepe',
    'America/Fortaleza',
    'America/Maceio',
    'America/Manaus',
    'America/Noronha',
    'America/Porto_Velho',
    'America/Recife',
    'America/Rio_Branco',
    'America/Santarem',
    'America/Sao_Paulo',
    'Indian/Chagos',
    'Asia/Brunei',
    'Europe/Sofia',
    'Africa/Ouagadougou',
    'Africa/Bujumbura',
    'Asia/Phnom_Penh',
    'Africa/Douala',
    'America/Atikokan',
    'America/Blanc-Sablon',
    'America/Cambridge_Bay',
    'America/Creston',
    'America/Dawson',
    'America/Dawson_Creek',
    'America/Edmonton',
    'America/Fort_Nelson',
    'America/Glace_Bay',
    'America/Goose_Bay',
    'America/Halifax',
    'America/Inuvik',
    'America/Iqaluit',
    'America/Moncton',
    'America/Rankin_Inlet',
    'America/Regina',
    'America/Resolute',
    'America/St_Johns',
    'America/Swift_Current',
    'America/Toronto',
    'America/Vancouver',
    'America/Whitehorse',
    'America/Winnipeg',
    'Atlantic/Cape_Verde',
    'America/Cayman',
    'Africa/Bangui',
    'Africa/Ndjamena',
    'America/Punta_Arenas',
    'America/Santiago',
    'Pacific/Easter',
    'Asia/Shanghai',
    'Asia/Urumqi',
    'Indian/Christmas',
    'Indian/Cocos',
    'America/Bogota',
    'Indian/Comoro',
    'Africa/Brazzaville',
    'Africa/Kinshasa',
    'Africa/Lubumbashi',
    'Pacific/Rarotonga',
    'America/Costa_Rica',
    'Europe/Zagreb',
    'America/Havana',
    'America/Curacao',
    'Asia/Famagusta',
    'Asia/Nicosia',
    'Europe/Prague',
    'Africa/Abidjan',
    'Europe/Copenhagen',
    'Africa/Djibouti',
    'America/Dominica',
    'America/Santo_Domingo',
    'America/Guayaquil',
    'Pacific/Galapagos',
    'Africa/Cairo',
    'America/El_Salvador',
    'Africa/Malabo',
    'Africa/Asmara',
    'Europe/Tallinn',
    'Africa/Addis_Ababa',
    'Atlantic/Stanley',
    'Atlantic/Faroe',
    'Pacific/Fiji',
    'Europe/Helsinki',
    'Europe/Paris',
    'America/Cayenne',
    'Pacific/Gambier',
    'Pacific/Marquesas',
    'Pacific/Tahiti',
    'Indian/Kerguelen',
    'Africa/Libreville',
    'Africa/Banjul',
    'Asia/Tbilisi',
    'Europe/Berlin',
    'Europe/Busingen',
    'Africa/Accra',
    'Europe/Gibraltar',
    'Europe/Athens',
    'America/Danmarkshavn',
    'America/Nuuk',
    'America/Scoresbysund',
    'America/Thule',
    'America/Grenada',
    'America/Guadeloupe',
    'Pacific/Guam',
    'America/Guatemala',
    'Europe/Guernsey',
    'Africa/Conakry',
    'Africa/Bissau',
    'America/Guyana',
    'America/Port-au-Prince',
    'Europe/Vatican',
    'America/Tegucigalpa',
    'Asia/Hong_Kong',
    'Europe/Budapest',
    'Atlantic/Reykjavik',
    'Asia/Kolkata',
    'Asia/Jakarta',
    'Asia/Jayapura',
    'Asia/Makassar',
    'Asia/Pontianak',
    'Asia/Tehran',
    'Asia/Baghdad',
    'Europe/Dublin',
    'Europe/Isle_of_Man',
    'Asia/Jerusalem',
    'Europe/Rome',
    'America/Jamaica',
    'Asia/Tokyo',
    'Europe/Jersey',
    'Asia/Amman',
    'Asia/Almaty',
    'Asia/Aqtau',
    'Asia/Aqtobe',
    'Asia/Atyrau',
    'Asia/Oral',
    'Asia/Qostanay',
    'Asia/Qyzylorda',
    'Africa/Nairobi',
    'Pacific/Kanton',
    'Pacific/Kiritimati',
    'Pacific/Tarawa',
    'Asia/Pyongyang',
    'Asia/Seoul',
    'Asia/Kuwait',
    'Asia/Bishkek',
    'Asia/Vientiane',
    'Europe/Riga',
    'Asia/Beirut',
    'Africa/Maseru',
    'Africa/Monrovia',
    'Africa/Tripoli',
    'Europe/Vaduz',
    'Europe/Vilnius',
    'Europe/Luxembourg',
    'Asia/Macau',
    'Europe/Skopje',
    'Indian/Antananarivo',
    'Africa/Blantyre',
    'Asia/Kuala_Lumpur',
    'Asia/Kuching',
    'Indian/Maldives',
    'Africa/Bamako',
    'Europe/Malta',
    'Pacific/Kwajalein',
    'Pacific/Majuro',
    'America/Martinique',
    'Africa/Nouakchott',
    'Indian/Mauritius',
    'Indian/Mayotte',
    'America/Bahia_Banderas',
    'America/Cancun',
    'America/Chihuahua',
    'America/Ciudad_Juarez',
    'America/Hermosillo',
    'America/Matamoros',
    'America/Mazatlan',
    'America/Merida',
    'America/Mexico_City',
    'America/Monterrey',
    'America/Ojinaga',
    'America/Tijuana',
    'Pacific/Chuuk',
    'Pacific/Kosrae',
    'Pacific/Pohnpei',
    'Europe/Chisinau',
    'Europe/Monaco',
    'Asia/Hovd',
    'Asia/Ulaanbaatar',
    'Europe/Podgorica',
    'America/Montserrat',
    'Africa/Casablanca',
    'Africa/El_Aaiun',
    'Africa/Maputo',
    'Asia/Yangon',
    'Africa/Windhoek',
    'Pacific/Nauru',
    'Asia/Kathmandu',
    'Europe/Amsterdam',
    'Pacific/Noumea',
    'Pacific/Auckland',
    'Pacific/Chatham',
    'America/Managua',
    'Africa/Niamey',
    'Africa/Lagos',
    'Pacific/Niue',
    'Pacific/Norfolk',
    'Pacific/Saipan',
    'Europe/Oslo',
    'Asia/Muscat',
    'Asia/Karachi',
    'Pacific/Palau',
    'Asia/Gaza',
    'Asia/Hebron',
    'America/Panama',
    'Pacific/Bougainville',
    'Pacific/Port_Moresby',
    'America/Asuncion',
    'America/Lima',
    'Asia/Manila',
    'Pacific/Pitcairn',
    'Europe/Warsaw',
    'Atlantic/Azores',
    'Atlantic/Madeira',
    'Europe/Lisbon',
    'America/Puerto_Rico',
    'Asia/Qatar',
    'Europe/Bucharest',
    'Asia/Anadyr',
    'Asia/Barnaul',
    'Asia/Chita',
    'Asia/Irkutsk',
    'Asia/Kamchatka',
    'Asia/Khandyga',
    'Asia/Krasnoyarsk',
    'Asia/Magadan',
    'Asia/Novokuznetsk',
    'Asia/Novosibirsk',
    'Asia/Omsk',
    'Asia/Sakhalin',
    'Asia/Srednekolymsk',
    'Asia/Tomsk',
    'Asia/Ust-Nera',
    'Asia/Vladivostok',
    'Asia/Yakutsk',
    'Asia/Yekaterinburg',
    'Europe/Astrakhan',
    'Europe/Kaliningrad',
    'Europe/Kirov',
    'Europe/Moscow',
    'Europe/Samara',
    'Europe/Saratov',
    'Europe/Ulyanovsk',
    'Europe/Volgograd',
    'Africa/Kigali',
    'Indian/Reunion',
    'America/St_Barthelemy',
    'Atlantic/St_Helena',
    'America/St_Kitts',
    'America/St_Lucia',
    'America/Marigot',
    'America/Miquelon',
    'America/St_Vincent',
    'Pacific/Apia',
    'Europe/San_Marino',
    'Africa/Sao_Tome',
    'Asia/Riyadh',
    'Africa/Dakar',
    'Europe/Belgrade',
    'Indian/Mahe',
    'Africa/Freetown',
    'Asia/Singapore',
    'America/Lower_Princes',
    'Europe/Bratislava',
    'Europe/Ljubljana',
    'Pacific/Guadalcanal',
    'Africa/Mogadishu',
    'Africa/Johannesburg',
    'Atlantic/South_Georgia',
    'Africa/Juba',
    'Africa/Ceuta',
    'Atlantic/Canary',
    'Europe/Madrid',
    'Asia/Colombo',
    'Africa/Khartoum',
    'America/Paramaribo',
    'Arctic/Longyearbyen',
    'Africa/Mbabane',
    'Europe/Stockholm',
    'Europe/Zurich',
    'Asia/Damascus',
    'Asia/Taipei',
    'Asia/Dushanbe',
    'Africa/Dar_es_Salaam',
    'Asia/Bangkok',
    'Asia/Dili',
    'Africa/Lome',
    'Pacific/Fakaofo',
    'Pacific/Tongatapu',
    'America/Port_of_Spain',
    'Africa/Tunis',
    'Europe/Istanbul',
    'Asia/Ashgabat',
    'America/Grand_Turk',
    'Pacific/Funafuti',
    'Africa/Kampala',
    'Europe/Kyiv',
    'Europe/Simferopol',
    'Asia/Dubai',
    'Europe/London',
    'America/Adak',
    'America/Anchorage',
    'America/Boise',
    'America/Chicago',
    'America/Denver',
    'America/Detroit',
    'America/Indiana/Indianapolis',
    'America/Indiana/Knox',
    'America/Indiana/Marengo',
    'America/Indiana/Petersburg',
    'America/Indiana/Tell_City',
    'America/Indiana/Vevay',
    'America/Indiana/Vincennes',
    'America/Indiana/Winamac',
    'America/Juneau',
    'America/Kentucky/Louisville',
    'America/Kentucky/Monticello',
    'America/Los_Angeles',
    'America/Menominee',
    'America/Metlakatla',
    'America/New_York',
    'America/Nome',
    'America/North_Dakota/Beulah',
    'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem',
    'America/Phoenix',
    'America/Sitka',
    'America/Yakutat',
    'Pacific/Honolulu',
    'Pacific/Midway',
    'Pacific/Wake',
    'America/Montevideo',
    'Asia/Samarkand',
    'Asia/Tashkent',
    'Pacific/Efate',
    'America/Caracas',
    'Asia/Ho_Chi_Minh',
    'America/Tortola',
    'America/St_Thomas',
    'Pacific/Wallis',
    'Asia/Aden',
    'Africa/Lusaka',
    'Africa/Harare',
    'Europe/Mariehamn'
];

export default timezones;
